// Default
import '../../custom/js/default';

//// JS
//import '../../custom/js/indexOptimized';

//// Base SCSS
//import '../../custom/scss/style.scss';